import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchRoomsApi,
  startMeetingApi,
  completeRoomApi,
  joinMeetingApi,
  checkJoinStatusApi,
  adminJoinMeetingApi,
  getWaitingParticipantsApi,
  approveParticipantApi,
  rejectParticipantApi,
  removeParticipantApi,
  leaveMeetingApi,
} from "../../../api/rooms";

export const fetchRoomsAction = createAsyncThunk(
  "room/fetchRoomsAction",
  async (userId, { rejectWithValue }) => {
    try {
      const data = await fetchRoomsApi(userId);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to fetch rooms");
    }
  }
);

export const createRoomAction = createAsyncThunk(
  "room/createRoomAction",
  async (roomData, { rejectWithValue }) => {
    try {
      const data = await startMeetingApi(roomData);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to create room");
    }
  }
);

export const joinMeetingAction = createAsyncThunk(
  "room/joinMeetingAction",
  async ({ roomCode, roomPassword, phoneNumber, identity }, { rejectWithValue }) => {
    try {
      const data = await joinMeetingApi({ roomCode, roomPassword, phoneNumber, identity });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to join meeting");
    }
  }
);

export const checkJoinStatusAction = createAsyncThunk(
  "room/checkJoinStatusAction",
  async ({ meetingCode, phoneNumber }, { rejectWithValue }) => {
    try {
      const data = await checkJoinStatusApi(meetingCode, phoneNumber);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to check status");
    }
  }
);

export const completeRoomAction = createAsyncThunk(
  "room/completeRoomAction",
  async ({ roomId, userId }, { rejectWithValue }) => {
    try {
      const data = await completeRoomApi(roomId, userId);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to complete room");
    }
  }
);

export const adminJoinMeetingAction = createAsyncThunk(
  "room/adminJoinMeetingAction",
  async ({ roomCode, roomPassword, identity, phoneNumber }, { rejectWithValue }) => {
    try {
      const data = await adminJoinMeetingApi({ roomCode, roomPassword, identity, phoneNumber });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to join as admin");
    }
  }
);

export const getWaitingParticipantsAction = createAsyncThunk(
  "room/getWaitingParticipantsAction",
  async (meetingCode, { rejectWithValue }) => {
    try {
      const data = await getWaitingParticipantsApi(meetingCode);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to fetch waiting participants");
    }
  }
);

export const approveParticipantAction = createAsyncThunk(
  "room/approveParticipantAction",
  async ({ roomCode, phoneNumber }, { rejectWithValue }) => {
    try {
      const data = await approveParticipantApi(roomCode, phoneNumber);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to approve participant");
    }
  }
);

export const rejectParticipantAction = createAsyncThunk(
  "room/rejectParticipantAction",
  async ({ roomCode, phoneNumber }, { rejectWithValue }) => {
    try {
      const data = await rejectParticipantApi(roomCode, phoneNumber);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to reject participant");
    }
  }
);

export const removeParticipantAction = createAsyncThunk(
  "room/removeParticipantAction",
  async ({ roomCode, phoneNumber }, { rejectWithValue }) => {
    try {
      const data = await removeParticipantApi(roomCode, phoneNumber);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to remove participant");
    }
  }
);

export const leaveMeetingAction = createAsyncThunk(
  "room/leaveMeetingAction",
  async ({ roomCode, phoneNumber }, { rejectWithValue }) => {
    try {
      const data = await leaveMeetingApi(roomCode, phoneNumber);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Failed to leave meeting");
    }
  }
);

// Backward-compatible aliases (pages use these names)
export const fetchRooms = fetchRoomsAction;
export const createRoom = createRoomAction;
export const requestJoin = joinMeetingAction;
export const checkJoinStatus = checkJoinStatusAction;
export const completeRoom = completeRoomAction;
export const adminJoinMeeting = adminJoinMeetingAction;
